import { ChangeDetectorRef, Component, DoCheck, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NrkWindowComponent } from '../../erp/shared/nrk-window/nrk-window.component';
import { WarehousingComponent } from '../warehousing.component';
import { EWarehousingEntryType, WarehousingModel } from '../../../@models/warehousing';
import { ApiService } from '../../../@core/service/api.service';
import { NbToastrService } from '@nebular/theme';
import { IDropdownOptions, SharedDataService } from '../../../@core/service/shared-data.service';
import { mongoId } from '../../../@core/common/global';
import { CompilationModel } from '../../../@models/erp/compilation';
import { AuthGuardService } from '../../../@core/service/auth-guard.service';
import { UserModel } from '../../../@models';
import { HeaderComponent } from '../../../@theme/components';

export enum EMessagingWindowMode {
  overview = 1,
  overviewWindow,
  messageWindow,
}

@Component({
  selector: 'ngx-messaging',
  templateUrl: './messaging.component.html',
  styleUrls: ['./messaging.component.scss']
})
export class MessagingComponent implements OnInit {

  @Input() compilation: CompilationModel;
  @Input() messagingMode = EMessagingWindowMode.overviewWindow;
  // @Input() message: WarehousingModel;
  @Output() close = new EventEmitter<WarehousingModel>();
  
  @ViewChild('messageWindow') messageWindow: NrkWindowComponent;

  protected messagingWindowMode = EMessagingWindowMode;
  mongoId = mongoId; // forward to template;

  messages: WarehousingModel[] = [];
  rootMessage: WarehousingModel;
  currentMessage: WarehousingModel = new WarehousingModel();
  currentText: string;

  editMessage = null;

  isOpen = false;
  // messageChecker: NodeJS.Timeout = null;

  recipientOptions: IDropdownOptions[];

  overviewMode = false;

  constructor(private api: ApiService, private toastr: NbToastrService, protected data: SharedDataService, protected auth: AuthGuardService, private cdRef: ChangeDetectorRef) {}

  async ngOnInit() {
    await this.data.loadUsers();
    this.recipientOptions = [{ id: null, name: 'All' }, ...this.data.userOptions];
    if (this.messagingMode === EMessagingWindowMode.overview) {
      this.overviewMode = true;
      this.reloadMessages();
    }
  }

  reset() {
    this.compilation = this.rootMessage = this.currentMessage = this.rootMessage = this.currentText = undefined;
    this.ngOnInit();
  }

  async reloadMessages() {

    // await this.data.loadWarehousing();
    const code = this.rootMessage?.code || this.compilation?.code;
    // this.messages = this.data.warehousingMessages?.filter(f => f.code === code);
    this.messages = (await this.api.loadWarehousingEntries({ code: code, entryType: EWarehousingEntryType.message }))?.filter(f => !f.deleted);

    // console.log('reload messages', await this.api.loadWarehousingEntries({ code: code, entryType: EWarehousingEntryType.message }), this.messages, this.rootMessage?.code, this.compilation.code, code);

  }

  async messageSubmit() {

    if (!this.currentText?.trim()) {
      this.toastr.danger('Message is empty', 'Can\'t send message')
      return;
    }
    if (!this.currentMessage.subject?.trim()) {
      this.toastr.danger('Subject is empty', 'Can\'t send message')
      return;
    }
    if (this.rootMessage && !this.rootMessage.children) {
      this.toastr.danger('Can\'t add messages to the legacy messaging system\nPlease create a new message', 'Can\'t send message')
      return;
    }

    if (this.rootMessage) {
      const newMessage = new WarehousingModel;
      newMessage.message = this.currentText;
      newMessage.user = this.auth.user;
      newMessage.timestamp = new Date();
      if (!this.rootMessage.children) this.rootMessage.children = []; // TODO: remove this legacy
      this.rootMessage.children.push(newMessage);
    } else {
      this.currentMessage.message = this.currentText;
      this.rootMessage = this.currentMessage;
    }

    this.currentText = '';
    // this.rootMessage.isReadBy = this.rootMessage.isReadBy?.filter(f => mongoId(f.user) !== mongoId(this.rootMessage.user) && mongoId(f.user) !== mongoId(this.rootMessage.recipient)) || [];
    // if (!this.rootMessage.isReadBy.find(f => mongoId(f.user) === mongoId(this.auth.user))) this.rootMessage.isReadBy.push(mongoId({user: this.auth.user, date: new Date() }))
    // this.currentMessage = this.rootMessage = await this.api.saveWarehousingEntry(this.rootMessage);
    // this.messageWindow.close();
    this.markasReadAndClose();
  }

  saveMessage(message: WarehousingModel) {
    // console.log('save message', message.message, this.rootMessage?.children?.find(f => f.timestamp === message?.timestamp && mongoId(f.user) === mongoId(this.auth?.user)), this.rootMessage)
    const childMsg = this.rootMessage?.children?.find(f => f.timestamp === message?.timestamp && mongoId(f.user) === mongoId(this.auth?.user));
    if (childMsg) {
      childMsg.message = message.message;
      // childMsg.timestamp = message.timestamp = new Date();
    }
    this.api.saveWarehousingEntry(this.rootMessage);
  }

  deleteMessage(message: WarehousingModel) {
    this.editMessage = null;
    message.deleted = true;
    this.api.saveWarehousingEntry(this.currentMessage);
    this.cdRef.detectChanges();
  }

  deleteMessageTree() {
    this.rootMessage.deleted = true;  
    this.api.saveWarehousingEntry(this.rootMessage);
    this.cdRef.detectChanges();
    this.hide();
  }

  async show(message: WarehousingModel = null) {

    if (!this.messages?.length && this.messagingMode === EMessagingWindowMode.overviewWindow) {
      this.reloadMessages();
    }

    const currCode = this.rootMessage?.code;

    this.currentMessage = this.rootMessage = message;

    // if (message) {
    //   if (message.children) await this.update(message);  // TODO: remove message.children test (--> legacy)
    // } else {
    //   this.currentMessage = this.createMessage(currCode);
    // }

    if (!message) {
      this.currentMessage = this.createMessage(currCode);
    }


    this.messageWindow.show();
    // this.messagingMode = EMessagingWindowMode.messageWindow;

    console.log('show message', message);
    // mark as read
    if (message && !message.isReadBy?.find(f => mongoId(f.user) === mongoId(this.auth.user))) {
      // message.isReadBy.push({ user: this.auth.user, date: new Date() })
      // console.log('mark as read', message)
      // console.log('result', await this.api.saveWarehousingEntry(message));
      this.api.markWarehousingEntryAsRead(message, this.auth.user).then(async () => {
        console.log('mark message as read', message, this.auth.user.short);
        await this.data.reloadWarehousing(true);
        HeaderComponent.readMessages();
      });
    }
    // console.log('show', message, this.currentMessage )
  }

  async update(message = this.currentMessage) {
    console.log('update', message, mongoId(message))
    if (mongoId(this.currentMessage)) this.currentMessage = await this.api.loadWarehousingEntry(mongoId(message));
  }

  hide() {
    this.messageWindow.hide();
  }

  createMessage(currCode) {
    const newMessage = new WarehousingModel();
    newMessage.user = mongoId(this.auth.user);
    newMessage.code = currCode || this.compilation?.code;
    newMessage.entryType = EWarehousingEntryType.message;
    newMessage.timestamp = new Date();
    return newMessage;
  }

  async markasReadAndClose() {
    if (this.rootMessage) {
      this.rootMessage.isReadBy = this.rootMessage.isReadBy?.filter(f => mongoId(f.user) !== mongoId(this.rootMessage.user) && mongoId(f.user) !== mongoId(this.rootMessage.recipient)) || [];
      if (!this.rootMessage.isReadBy.find(f => mongoId(f.user) === mongoId(this.auth.user))) this.rootMessage.isReadBy.push(mongoId({user: this.auth.user, date: new Date() }))
      this.currentMessage = this.rootMessage = await this.api.saveWarehousingEntry(this.rootMessage);
    }
    this.messageWindow.close();
  }

  onOpen() {
    this.isOpen = true;
    // if (this.messageChecker) {
    //   clearInterval(this.messageChecker);
    // }
    // this.messageChecker = setInterval(async () => {
    //   if (mongoId(this.currentMessage)) this.currentMessage = await this.api.loadWarehousingEntry(mongoId(this.currentMessage));
    // }, 5000)
  }

  onClose() {
    this.isOpen = false
    // clearInterval(this.messageChecker);
    // this.messageChecker = null;
    this.close.emit(this.rootMessage);
  }

  getClass(user: UserModel) {
    if (mongoId(this.auth.user) === mongoId(user)) return 'message-user';
    if (mongoId(this.rootMessage?.recipient) === mongoId(user)) return 'message-recipient';
    return 'message-alien';
  }

}


// @Component({
//   selector: 'ngx-messaging',
//   templateUrl: './messaging.component.html',
//   styleUrls: ['./messaging.component.scss']
// })
// export class MessagingComponent implements OnInit, OnChanges {

//   @Input() compilation: CompilationModel;
//   @Input() messagingType = EMessagingWindowType.overviewWindow;
//   @Input() message: WarehousingModel;
  
//   @ViewChild('messageWindow') messageWindow: NrkWindowComponent;

//   messagingWindowType = EMessagingWindowType;
//   mongoId = mongoId; // forward to template;

//   currentCode: string;
//   currentMessage: WarehousingModel = new WarehousingModel();
//   messages: WarehousingModel[] = [];
//   messageBackup: WarehousingModel = new WarehousingModel();;

//   recipientOptions: IDropdownOptions[];

//   refMessageMap: { [id: string]: WarehousingModel } = {}
//   historyMap: { [id: string]: WarehousingModel }[] = []
  
//   overviewMode = false;

//   constructor(private api: ApiService, private toastr: NbToastrService, protected data: SharedDataService, protected auth: AuthGuardService) { 
//     this.recipientOptions = [{ id: null, name: 'All' }, ...data.userOptions];
//   }
//   ngOnInit() {
//     console.log('messaging mode', EMessagingWindowType[this.messagingType]);
//     if (this.messagingType === EMessagingWindowType.overview) this.overviewMode = true;
//     if (this.message) this.currentMessage = this.message;
//     this.reloadMessages();
//   }

//   ngOnChanges(changes: SimpleChanges): void {
//     if (changes.message?.currentValue) {
//       this.currentMessage = changes.message.currentValue;
//       this.reloadMessages();
//     }
//   }

//   show() {
//     this.messageWindow.show();
//   }

//   hide() {
//     this.messageWindow.hide();
//   }

//   async reloadMessages() {
//     await this.data.loadWarehousing();
//     if (this.message || this.compilation) {
//       this.currentCode = (!this.compilation && this.currentMessage) ? this.currentMessage.code : this.compilation.code;
//       this.messages = this.data.warehousingMessages?.filter(f => f.code === this.currentCode && !f.deleted);
//       this.messages.forEach(msg => this.refMessageMap[mongoId(msg)] = msg);
//     }
//     console.log('reload messages', this.compilation, this.currentMessage, this.messages, this.historyMap);
//   }

//   setCurrentMessage(message: WarehousingModel, fromWindow: boolean) {
//     this.currentMessage = message;
//     if (!fromWindow && !this.messageWindow.isOpen) this.messageWindow.show();
//     this.messagingType = EMessagingWindowType.editMessage;
//   }

//   deleteMessage(message: WarehousingModel) {
//     if (this.messages.find(f => mongoId(f.prev) === mongoId(message))) {
//       this.toastr.danger('this message can\'t be deleted because it has attached messages', 'Error');
//     }
//     message.deleted = true;
//     console.log('reziprok????', message)
//     this.api.saveWarehousingEntry(message).then(() => this.reloadMessages());
//     this.messageWindow.hide();
//   }

//   replyMessage(message: WarehousingModel) {
//     this.messageBackup = Object.assign({}, this.currentMessage);
//     const reply = new WarehousingModel();
//     reply.recipient = message.user;
//     reply.code = message.code;
//     // reply.subject = 'Re: ' + message.subject;
//     reply.subject = message.subject;
//     const user = this.data.users.find(f => mongoId(f) === mongoId(this.currentMessage.user))?.name;
//     // reply.message = `\n> On ${new Date(message.timestamp).toISOString().replace(/[TZ]/g, ' ').replace(/\:\d\d\.\d*/,'')} ${user} wrote:\n` 
//     //   + this.currentMessage.message.trim().split('\n').map(m => ' > ' + m).join('\n');
    
//     // this.currentMessage = reply;
//     this.currentMessage.children?.push(reply);
//     this.messagingType = this.messagingWindowType.writeMessage
//     // this.data.warehousingMessages?.push(this.currentMessage);
//   }

//   newMessage() {
//     this.currentMessage = new WarehousingModel();
//     this.messagingType = this.messagingWindowType.writeMessage
//     this.data.warehousingMessages?.push(this.currentMessage);
//   }

//   commitMessage() {
//     console.log('currentmessage', this.currentMessage, this.messageBackup);
//     this.currentMessage.entryType = EWarehousingEntryType.message;
//     this.currentMessage.user = this.auth.user;
//     this.currentMessage.timestamp = new Date();
//     if (this.currentCode) this.currentMessage.code = this.currentCode;

//     if (!this.currentMessage?.subject?.length) {
//       this.toastr.danger('Subject text is required', 'No Subject');
//       return;
//     }
//     // if (!this.currentMessage?.message?.length) {
//     //   this.toast.danger('Message text is required', 'No Message');
//     //   return;
//     // }
    
//     console.log('commit message', this.currentMessage);
//     this.api.saveWarehousingEntry(this.currentMessage).then(res => {
//       if (res) {
//         this.toastr.success('Message successfully sent', 'Message sent');
//         // this.messagingType = EMessagingWindowType.overview;
//         this.data.reloadWarehousing();
//       } else {
//         this.toastr.danger('Error while sending message', 'Server Error');
//       }
//     });
//     this.hide();
//   }

//   updateMessage(message: WarehousingModel) {
//     message.isReadBy = [];
//     this.currentMessage = message;
//     this.commitMessage();
//   }

//   restoreMessage() {
//     this.currentMessage = this.messageBackup;
//   }

//   onClose() {
//     this.restoreMessage();
//   }

//   markMessageAsRead(message: WarehousingModel) {
//     message.isReadBy.push({user: mongoId(this.auth.user), date: new Date()});
//     this.api.markWarehousingEntryAsRead(message, this.auth.user);
//     this.messageWindow.hide();
//   }



// }
